import { ApplicationRef, inject, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import {
	concat,
	first, interval } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DatapassService } from './datapass.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
	private appRef = inject(ApplicationRef);
	private swUpdate = inject(SwUpdate);
	private dataPassService = inject(DatapassService);

	constructor() {
		// Allow the app to stabilize first, before starting
		// polling for updates with `interval()`.
		if (this.swUpdate?.isEnabled) {
			const appIsStable$ = this.appRef.isStable.pipe(first((isStable) => isStable === true));
			const everySixHours$ = interval(6 * 60 * 60 * 1000);
			const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
			everySixHoursOnceAppIsStable$.subscribe(async () => {
				this.checkForUpdates();
				// try {
				// 	const updateFound = await this.swUpdate.checkForUpdate();
				// 	console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
				// 	alert(updateFound ? 'A new version is available.' : 'Already on the latest version.');
				// } catch (err) {
				// 	console.error('Failed to check for updates:', err);
				// 	alert('Failed to check for updates. Please try again later.');
				// }
			});
		}
	}

	public checkForUpdates(): void {
		const updatesAvailable = this.swUpdate.versionUpdates.pipe(
			filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
			map((evt: VersionReadyEvent) => ({
				type: 'UPDATE_AVAILABLE',
				current: evt.currentVersion,
				available: evt.latestVersion,
			})));
		updatesAvailable.subscribe(event => { this.promptUser(); });
		this.swUpdate.unrecoverable.subscribe(event => { this.promptUser(); });
	}

	checkForUpdate() {
		console.log('checkForUpdate', this.swUpdate.isEnabled);
		if (!this.swUpdate.isEnabled) {
			return;
		}

		this.swUpdate.versionUpdates.subscribe((evt: VersionEvent) => {
			switch (evt.type) {
				case 'VERSION_DETECTED':
					console.log(`Downloading new app version: ${evt.version.hash}`);
					break;
				case 'VERSION_READY':
					console.log(`Current app version: ${evt.currentVersion.hash}`);
					console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
					break;
				case 'VERSION_INSTALLATION_FAILED':
					console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
					break;
				case 'NO_NEW_VERSION_DETECTED':
					console.log(`No new version detected`);
					break;
			}
		});

		// try {
		// 	const updateFound = await this.swUpdate.checkForUpdate();
		// 	if (!updateFound) {
		// 		alert('You are already on the latest version.');
		// 	}
		// } catch (err) {
		// 	console.error('Failed to check for updates:', err);
		// 	alert('Failed to check for updates. Please try again later.');
		// }
	}

	private promptUser(): void {
		this.dataPassService.setAskUpdateModalSource({ isOpen: true });
	}
}
